export enum STATUS_CODES {
    SUCCESS = 200,
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    REDIRECT = 403,
    MOVED_TEMPORARILY = 302,
    INTERNAL_ERROR = 500,
}
